import { useServerSideFilters } from "@/hooks/useQueryFilters";
import { accountingTransactionsReadyToExportFilter } from "../utils/transactions-todos-filter";
import { useTransactionsLiveCountsSubscription } from "./live-counts";

export const useAccountingTransactionsReadyToExportLiveCount = () => {
  const serverSideQuery = useServerSideFilters({
    query: accountingTransactionsReadyToExportFilter,
  });

  const { liveCounts, loading } = useTransactionsLiveCountsSubscription({
    query: serverSideQuery,
  });

  return { liveCounts, loading };
};
